let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6bbq0")).then(() => parcelRequire('7ptXp'));